"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
/**
 * Open accordion
 */
var Accordion = /** @class */ (function () {
    function Accordion() {
        this.init();
    }
    Accordion.prototype.init = function () {
        this.accordions = document.querySelectorAll("[".concat(constants_1.DATA_ACCORDION_OPEN, "]"));
        this.initEventListeners();
    };
    /**
     * Init listeners
     * @private
     */
    Accordion.prototype.initEventListeners = function () {
        var _a;
        (_a = this.accordions) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
            var content = element.nextElementSibling;
            element.addEventListener('click', function () {
                element.classList.toggle(constantsClasses_1.CLASS_ACTIVE);
                content.classList.toggle(constantsClasses_1.CLASS_ACTIVE);
            });
        });
    };
    return Accordion;
}());
exports.default = Accordion;
